import HTTPClient from './http-client';

const END_POINT = '/monthlysummary';
const options = {
    cache: {
        maxAge: 5 * 60 * 1000,
        exclude: { query: false }
    }
};

const loadSummaryMonth = async (initial_date, final_date, source, customer_id) =>{
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
        `${END_POINT}?date_start=${initial_date}&date_end=${final_date}&source_ids=${source}&customer_ids=${customer_id}`,
        options
    );
};

const loadSummaryMonths = async ({source, id, date_end, date_start}) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}?date_start=${date_start}&date_end=${date_end}&source_ids=${source}&location_ids=${id}`,
    options
  );
}

export {
  loadSummaryMonth,
  loadSummaryMonths,
}
